import { Vector2, Vector3 } from "three";
import * as Three from "three";

export class Debris {
  id: number;
  initialPosition: Vector3;
  color: Three.Color = new Three.Color();
  position: Vector3;
  trajectory: Vector2;

  static matrix = new Three.Matrix4();

  constructor(pos: Vector3, id: number) {
    this.id = id;
    this.initialPosition = pos;
    this.position = this.initialPosition.clone();
    // const lightness = 5;
    const lightness = 5 + 50 * (1 - -this.position.z / 1000);
    this.color = new Three.Color(lightness, lightness, lightness);
    const trajectoryMult = 3
    this.trajectory = new Vector2(
      +(0.001*trajectoryMult) + Math.random() * (0.002 * trajectoryMult),
      -(0.001*trajectoryMult) + Math.random() * (0.006 * trajectoryMult),
    );
  }

  thirdFrameCounter = 0;


  update(
    mesh: Three.InstancedMesh,
    obj: Three.Object3D,
    cameraTarget: Vector3,
    cameraZoom: number,
  ) {
    // this.position.x += 0.001;
    // this.position.y -= 0.001;
    const dist = 40;
    const depth = 5000;
    const originX =
      Math.ceil((cameraTarget.x - dist / 2 - this.position.x) / dist) * dist;
    const originY =
      Math.ceil((cameraTarget.y - dist / 2 - this.position.y) / dist) * dist;
    const originDepth = Math.min(10000,
      Math.ceil((cameraZoom - depth - this.position.z) / depth) * depth
    )
    this.position.x += this.trajectory.x;
    this.position.y += this.trajectory.y;
    obj.position.set(
      originX + this.position.x,
      originY + this.position.y,
      originDepth + this.position.z,
    );
    obj.updateMatrix();
    if (this.thirdFrameCounter > 1) {
      this.thirdFrameCounter = 0;
      const distFromCenter = new Vector2(
        cameraTarget.x,
        cameraTarget.y,
      ).distanceTo(
        new Vector2(originX + this.position.x, originY + this.position.y),
      );
      const distFromCenterNormalized =
        1 - Math.min(distFromCenter / (dist / 2), 1);
      const prelightness = 10 + 50 * (1 - -this.position.z / 5000);
      const lightness = prelightness * distFromCenterNormalized;
      // console.log(distFromCenterNormalized);
      // const lightness = 50 * this.thirdFrameCounter;
      this.color.set(lightness, lightness, lightness)
      mesh.setColorAt(this.id, this.color);
      mesh.instanceColor.needsUpdate = true;
    }
    mesh.setMatrixAt(this.id, obj.matrix);
    mesh.instanceMatrix.needsUpdate = true;
    this.thirdFrameCounter += 1;
  }
}
